export default {
  SET_NOTIFICATION_DATA(state, notificationData) {
    state.notifications = notificationData;
  },
};
